import Model, { attr } from '@ember-data/model';

export interface PropertyUserSettingItem {
  l: string;
  show?: boolean;
  hide?: boolean;
}

export default class ContactCustomPropertyUserSettingModel extends Model {
  @attr() detailPage!: PropertyUserSettingItem[];
  @attr() tableColumns!: PropertyUserSettingItem[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'contact-custom-property-user-setting': ContactCustomPropertyUserSettingModel;
  }
}
